module.exports = __webpack_public_path__ + "img/categorie-commentcamarche-famille-boutrais.2f018811.webp";